import React, { Component } from "react";
import Header from "./header";
import swal from "sweetalert";
import Swal from "sweetalert2";
import { MdAddCircle } from "react-icons/md";
import { MdModeEdit } from "react-icons/md";
import { MdDeleteForever, MdError } from "react-icons/md";
import { MdDelete } from "react-icons/md";
import io from "socket.io-client";
import jwt_decode from "jwt-decode";
const url = "https://transacoes-api.all.com.br:3080";
const uuidv4 = require("uuid/v4");
let items = [];

class Register extends Component {
  state = {
    userEmail: "",
    tipo: "",
    descricao: "",
    patrimonio: "",
    destino: "",
    observacao: "",
    idRemetente: "",
    idDestinatario: "",
    adicionado: false,
    concluido: false,
    disableActions: true,
    disabled: true,
    idItemUpdate: "",
    actionLabel: "Adicionar",
    actionInsert: true,
    actionEdit: false,
    employees: [],
    username: "",
    lastIdItem: 0,
    restChar: 0
  };

  socket = io(url);

  async componentDidMount() {
    this.eventListenerSocket();
    await this.getUserLogged();
    await this.setLocalStorageItems();
    this.getEmployees();
    this.getLastIdItem();
  }

  eventListenerSocket = () => {
    this.socket.on("data", () => this.getLastIdItem());
  };

  getUserLogged = async () => {
    if (localStorage.getItem("token") !== null) {
      const userToken = JSON.parse(localStorage.getItem("token").toString());
      let decoded = jwt_decode(userToken.token);
      await this.setState({
        userEmail: decoded.email,
        idRemetente: decoded.id.toString(),
        username: decoded.usuario
      });
    } else
      this.setState({
        userEmail: "",
        idRemetente: "",
        username: ""
      });
  };

  getEmployees = () => {
    fetch(`${url}/funcionarios`)
      .then(response => response.json())
      .then(employee => {
        if (employee)
          this.setState({
            employees: employee
          });
        else this.setState({ employees: [] });
      });
  };

  getLastIdItem = () => {
    fetch(`${url}/id_item`)
      .then(response => response.json())
      .then(lastIdItem => {
        if (lastIdItem)
          this.setState({
            lastIdItem: lastIdItem
          });
        else this.setState({ lastIdItem: 0 });
      });
  };

  setLocalStorageItems = () => {
    if (localStorage.getItem("items") !== null) {
      items = JSON.parse(localStorage.getItem("items").toString());
      if (items.length === 0) {
        this.setState({ disabled: true });
      } else {
        this.setState({
          concluido: true,
          disabled: false,
          actionLabel: "Adicionar"
        });
      }
    } else
      this.setState({
        disabled: true
      });
  };

  handleClear = () => {
    this.setState({
      tipo: "",
      descricao: "",
      patrimonio: "",
      destino: "",
      observacao: "",
      idRemetente: this.state.idRemetente,
      idDestinatario: "",
      actionInsert: true,
      actionEdit: false,
      actionLabel: "Adicionar",
      disableActions: true,
      restChar: 0
    });
    this.refs.select.value = "-1";
    this.refs.descricao.value = "";
    this.refs.patrimonio.value = "";
    this.refs.destino.value = "-1";
    this.refs.observacao.value = "";
  };

  handleSave = () => {
    swal({
      title: "Confirmar inserção?",
      buttons: true
    }).then(willConfirm => {
      if (willConfirm) {
        Swal.fire({
          title: "Inserindo...",
          onBeforeOpen: () => {
            Swal.showLoading();
          }
        });
        fetch(`${url}/inserir/transacao`, {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            items,
            userEmail: this.state.userEmail !== "" ? this.state.userEmail : "",
            token: JSON.parse(localStorage.getItem("token").toString()).token
          })
        }).then(response => {
          if (response.status !== 200) {
            Swal.close();
            swal({
              title: "Operação falhou!",
              text: "Erro na requisição.",
              icon: "error"
            });
          } else {
            Swal.close();
            swal({ icon: "success", title: "Inserido com sucesso!" }).then(
              () => {
                this.socket.emit("data");
                localStorage.removeItem("items");
                window.location.href = "/cadastro";
              }
            );
          }
        });
      }
    });
  };

  newItem = () => {
    const {
      tipo,
      descricao,
      patrimonio,
      destino,
      observacao,
      idRemetente,
      idDestinatario
    } = this.state;
    items.push({
      id: uuidv4(),
      tipo: tipo.toUpperCase(),
      descricao: descricao.toUpperCase(),
      patrimonio: patrimonio,
      destino: destino,
      observacao: observacao,
      idRemetente: idRemetente,
      idDestinatario: idDestinatario
    });
    localStorage.setItem("items", JSON.stringify(items));
  };

  editItem = item => {
    this.handleModalClick();
    this.setState({
      tipo: item.tipo.toUpperCase(),
      descricao: item.descricao.toUpperCase(),
      patrimonio: item.patrimonio,
      destino: item.destino,
      observacao: item.observacao,
      idRemetente: item.idRemetente,
      idDestinatario: item.idDestinatario,
      actionLabel: "Atualizar",
      disableActions: false,
      actionInsert: false,
      actionEdit: true,
      idItemUpdate: item.id,
      restChar: item.observacao.length
    });
    this.refs.select.value =
      item.tipo !== null ? item.tipo.toUpperCase() : "-1";
    this.refs.descricao.value =
      item.descricao !== null ? item.descricao.toUpperCase() : "";
    this.refs.patrimonio.value =
      item.patrimonio !== null ? item.patrimonio : "";
    this.refs.destino.value = item.destino !== null ? item.destino : "-1";
    this.refs.observacao.value =
      item.observacao !== null ? item.observacao : "";
  };

  updateItem = idItem => {
    let id = items.find(items => items.id === idItem);
    if (id) {
      const {
        tipo,
        descricao,
        patrimonio,
        destino,
        observacao,
        idRemetente,
        idDestinatario
      } = this.state;
      let idPosition = items.indexOf(id);
      items.splice(idPosition, 1);
      items.push({
        id: id,
        tipo: tipo.toUpperCase(),
        descricao: descricao.toUpperCase(),
        patrimonio: patrimonio,
        destino: destino,
        observacao: observacao,
        idRemetente: idRemetente,
        idDestinatario: idDestinatario
      });
      localStorage.setItem("items", JSON.stringify(items));
    }
  };

  deleteItem = item => {
    swal({
      title: "Remover item?",
      buttons: true
    }).then(willConfirm => {
      if (willConfirm) {
        if (items.length === 1) items.splice(0, items.length);
        let id = items.find(items => items.id === item.id);
        let idPosition = items.indexOf(id);
        items.splice(idPosition, 1);
        localStorage.setItem("items", JSON.stringify(items));
        window.location.reload();
      }
    });
  };

  deleteAllItems = () => {
    swal({
      title: "Esvaziar malote?",
      buttons: true
    }).then(willConfirm => {
      if (willConfirm) {
        items.splice(0, items.length);
        localStorage.setItem("items", JSON.stringify(items));
        window.location.reload();
      }
    });
  };

  setRecipient = name => {
    let selectEmployee = this.state.employees.filter(
      employee => employee.usuario.toLowerCase() === name.toLowerCase()
    );
    if (selectEmployee.length > 0)
      this.setState({
        idDestinatario: selectEmployee[0].id
      });
    else {
      this.setState({ idDestinatario: "" });
    }
  };

  setFinish = e => {
    if (this.state.actionInsert) {
      e.preventDefault();
      this.refs.clear.click();
      this.newItem();
      if (items.length > 0) {
        this.setState({
          concluido: true,
          adicionado: true,
          disabled: false,
          actionInsert: true,
          actionEdit: false,
          actionLabel: "Adicionar",
          disableActions: true
        });
      }
    }
    if (this.state.actionEdit) {
      e.preventDefault();
      this.refs.clear.click();
      this.updateItem(this.state.idItemUpdate);
      if (items.length > 0) {
        this.setState({
          concluido: true,
          adicionado: true,
          disabled: false,
          actionInsert: true,
          actionEdit: false,
          actionLabel: "Adicionar",
          disableActions: true
        });
      }
    }
  };

  submitForm = () => {
    if (this.refs.select.value === "-1")
      swal({ title: "Selecione um tipo!", icon: "warning" });
    else if (this.refs.destino.value === "-1")
      swal({ title: "Selecione um destinatário!", icon: "warning" });
    else {
      this.refs.submitItems.click();
    }
  };

  backHome = () => {
    swal({
      title: "Deseja cancelar envio?",
      text: "Todos os itens serão descartados!",
      buttons: true
    }).then(willConfirm => {
      if (willConfirm) {
        localStorage.removeItem("items");
        window.location.href = "/painel";
      }
    });
  };

  handleModalClick = () => {
    this.refs.modalItem.click();
    this.handleClear();
  };

  countChar = e => {
    let length = e.target.value.length;
    if (length > 1000) {
      e.target.value = e.target.value.substring(0, 1000);
    } else {
      this.setState({ restChar: length });
    }
  };

  render() {
    return (
      <React.Fragment>
        <Header title={"Cadastro"} activeNavContent={true} />
        <button
          hidden
          type="button"
          className="btn btn-primary right"
          data-toggle="modal"
          data-target="#modalItem"
          ref="modalItem"
        />
        <form
          onSubmit={e => {
            this.setFinish(e);
            this.handleClear();
          }}
          ref="form"
        >
          <div
            className="modal fade"
            id="modalItem"
            tabIndex="-1"
            role="dialog"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="exampleModalLabel">
                    Novo Item
                  </h5>
                  <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                    onClick={() => this.handleClear()}
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div className="modal-body" style={{ paddingTop: "25px" }}>
                  <div className="row" align="center">
                    <div className="col s12" align="center">
                      <label
                        id="select"
                        className="col s12"
                        htmlFor="select"
                        align="center"
                        title="Obrigatório!"
                        style={{ color: "black" }}
                      >
                        Tipo:
                        <MdError style={{ fontSize: "0.8rem" }} />
                      </label>
                    </div>
                  </div>
                  <div className="row" align="center">
                    <div className="col s12" align="center">
                      <center>
                        <select
                          style={{ width: "82%" }}
                          className="form-control"
                          ref="select"
                          align="center"
                          required
                          id="select"
                          onChange={e =>
                            this.setState({
                              tipo: e.target.value,
                              disableActions: false
                            })
                          }
                          defaultValue={this.state.tipo}
                        >
                          <option value="-1" disabled>
                            Tipo...
                          </option>
                          <option value="DOCUMENTO">DOCUMENTO</option>
                          <option value="EQUIPAMENTO">EQUIPAMENTO</option>
                          <option value="SIGILOSO">SIGILOSO</option>
                          <option value="OUTRO">OUTRO</option>
                        </select>
                      </center>
                    </div>
                  </div>
                  <div className="row" align="center">
                    <div className="col s12" align="center">
                      <label
                        id="destino"
                        htmlFor="destino"
                        className="input-field"
                        align="center"
                        title="Obrigatório!"
                        style={{ color: "black" }}
                      >
                        Destinatário:
                        <MdError style={{ fontSize: "0.8rem" }} />
                      </label>
                    </div>
                  </div>
                  <div className="row" align="center">
                    <div className="col s12" align="center">
                      <center>
                        <select
                          style={{ width: "82%" }}
                          className="form-control"
                          ref="destino"
                          align="center"
                          required
                          id="destino"
                          onChange={e => {
                            this.setRecipient(e.target.value);
                            this.setState({
                              destino: e.target.value,
                              disableActions: false
                            });
                          }}
                          defaultValue={this.state.destino}
                        >
                          <option value="-1" disabled>
                            Destinatário..
                          </option>
                          {this.state.employees.length > 0 &&
                            this.state.employees.map(
                              (employee, i) =>
                                employee.usuario !== this.state.username && (
                                  <option key={i} value={employee.usuario}>
                                    {employee.usuario
                                      .toUpperCase()
                                      .replace(".", " ")}
                                  </option>
                                )
                            )}
                        </select>
                      </center>
                    </div>
                  </div>
                  <div className="row" align="center">
                    <div className="col s12" align="center">
                      <label
                        id="descricao"
                        htmlFor="descricao"
                        className="input-fiel col s12"
                        align="center"
                        title="Obrigatório!"
                        style={{ color: "black" }}
                      >
                        Descrição:
                        <MdError style={{ fontSize: "0.8rem" }} />
                      </label>
                    </div>
                  </div>
                  <div className="row" align="center">
                    <div className="col s12" align="center">
                      <input
                        style={{ color: "black" }}
                        required
                        ref="descricao"
                        className="input-field"
                        type="text"
                        align="center"
                        maxLength="100"
                        placeholder="Descrição..."
                        defaultValue={this.state.descricao}
                        onChange={e =>
                          this.setState({
                            descricao: e.target.value,
                            disableActions: false
                          })
                        }
                      />
                    </div>
                  </div>
                  <div className="row" align="center">
                    <div className="col s12" align="center">
                      <label
                        id="patrimonio"
                        htmlFor="patrimonio"
                        className="input-field"
                        align="center"
                        style={{ color: "black" }}
                      >
                        Código/Patrimônio:
                      </label>
                    </div>
                  </div>
                  <div className="row" align="center">
                    <div className="col s12" align="center">
                      <input
                        style={{ color: "black" }}
                        ref="patrimonio"
                        align="center"
                        maxLength="30"
                        className="input-field"
                        type="text"
                        placeholder="Código/Valor..."
                        onChange={e =>
                          this.setState({
                            patrimonio: e.target.value,
                            disableActions: false
                          })
                        }
                        defaultValue={this.state.patrimonio}
                      />
                    </div>
                  </div>
                  <div className="row" align="center">
                    <div className="col s12" align="center">
                      <label
                        id="observacao"
                        htmlFor="observacao"
                        className="input-field"
                        align="center"
                        style={{ color: "black" }}
                      >
                        Observação:&nbsp;
                        <span
                          id="rest"
                          style={{
                            fontSize: "0.9rem",
                            color: "black"
                          }}
                        >
                          <strong>
                            (
                            {this.state.restChar &&
                              this.state.restChar.toString()}
                            /1000)
                          </strong>
                        </span>
                      </label>
                    </div>
                  </div>
                  <div className="row" align="center">
                    <div className="col s12" align="center">
                      <textarea
                        style={{ color: "black", width: "82%" }}
                        ref="observacao"
                        align="center"
                        className="materialize-textarea"
                        type="text"
                        maxLength="1000"
                        placeholder="Observação..."
                        onKeyUp={e => this.countChar(e)}
                        onChange={e =>
                          this.setState({
                            observacao: e.target.value,
                            disableActions: false
                          })
                        }
                        defaultValue={this.state.observacao}
                      />
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <div className="row">
                    <div className="col s6">
                      <button
                        type="button"
                        ref="clear"
                        className="btn btn-secondary"
                        data-dismiss="modal"
                        onClick={() => this.handleClear()}
                      >
                        Cancelar
                      </button>
                    </div>
                    {this.state.actionInsert && (
                      <div className="col s6">
                        <button
                          type="button"
                          className="btn btn-primary"
                          disabled={this.state.disableActions}
                          onClick={() => this.submitForm()}
                        >
                          {this.state.actionLabel}
                        </button>
                        <button type="submit" ref="submitItems" hidden />
                      </div>
                    )}
                    {this.state.actionEdit && (
                      <div className="col s6">
                        <button
                          type="button"
                          className="btn btn-primary"
                          disabled={this.state.disableActions}
                          onClick={() => this.submitForm()}
                        >
                          {this.state.actionLabel}
                        </button>
                        <button type="submit" ref="submitItems" hidden />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
        <div className="container">
          <center>
            <form
              onSubmit={() => {
                this.handleSave();
              }}
              className="container envelope"
              style={{
                float: "center",
                margin: "auto",
                display: "block",
                paddingTop: "25px"
              }}
            >
              <div
                className="accordion md-accordion accordion-blocks"
                id="accordionEx78"
                role="tablist"
                aria-multiselectable="true"
                style={{
                  alignContent: "left",
                  backgroundColor: "white",
                  boxShadow:
                    "0 2px 5px rgba(0, 0, 0, 0.12), 0 2px 5px rgba(0, 0, 0, 0.24)",
                  display: "block",
                  margin: "auto"
                }}
              >
                <div className="card white" id={"card"}>
                  <div
                    className="card-header"
                    role="tab"
                    id={"headingUnfiled"}
                    style={{
                      backgroundColor: "#357ae8"
                    }}
                  >
                    <a
                      data-toggle="collapse"
                      data-parent={"#card"}
                      href={"#collapseUnfiled"}
                      aria-expanded="true"
                      aria-controls="collapseUnfiled"
                    >
                      <h5 className="mt-2 mb-0">
                        <span style={{ color: "white" }}>
                          <strong>Novo Malote</strong>
                          <div
                            className="right"
                            onClick={() => {
                              this.handleModalClick();
                            }}
                            title="Inserir novo item"
                            style={{ display: "block", paddingLeft: "10px" }}
                          >
                            <MdAddCircle />
                          </div>
                          <div
                            className="right"
                            onClick={() => {
                              this.deleteAllItems();
                            }}
                            title="Remover todos os itens"
                          >
                            <MdDelete />
                          </div>
                        </span>
                      </h5>
                    </a>
                  </div>
                  <div
                    className="collapse show"
                    role="tabpanel"
                    aria-labelledby={"headingUnfiled"}
                    data-parent={"#card"}
                  >
                    <div className="card-body">
                      {this.state.concluido && items.length > 0 ? (
                        <React.Fragment>
                          <table className="table register-table table-sm table-hover">
                            <thead>
                              <tr>
                                <th scope="col">Tipo</th>
                                <th scope="col">Destinatário</th>
                                <th scope="col">Descrição</th>
                                <th scope="col">Código/Patrimônio</th>
                                <th scope="col">Observação</th>
                                <th scope="col">Ações</th>
                              </tr>
                            </thead>
                            <tbody>
                              {items.map((item, i) => (
                                <tr key={i}>
                                  <td>{item.tipo.toUpperCase()}</td>
                                  <td>
                                    {item.destino
                                      .toUpperCase()
                                      .replace(".", " ")}
                                  </td>
                                  <td>
                                    {item.descricao &&
                                      (item.descricao.length <= 15 ? (
                                        item.descricao
                                      ) : (
                                        <textarea
                                          style={{ border: "none" }}
                                          className="form-control white"
                                          id="view_descricao"
                                          maxLength="100"
                                          value={item.descricao}
                                          readOnly
                                        />
                                      ))}
                                  </td>
                                  <td>
                                    {item.patrimonio ? (
                                      item.patrimonio.length <= 15 ? (
                                        item.patrimonio
                                      ) : (
                                        <textarea
                                          style={{ border: "none" }}
                                          className="form-control white"
                                          id="view_patrimonio"
                                          maxLength="30"
                                          value={item.patrimonio}
                                          readOnly
                                        />
                                      )
                                    ) : (
                                      "----"
                                    )}
                                  </td>
                                  <td>
                                    {item.observacao ? (
                                      item.observacao.length <= 15 ? (
                                        item.observacao
                                      ) : (
                                        <textarea
                                          style={{ border: "none" }}
                                          className="form-control white"
                                          id="view_observacao"
                                          maxLength="1000"
                                          value={item.observacao}
                                          readOnly
                                        />
                                      )
                                    ) : (
                                      "----"
                                    )}
                                  </td>
                                  <td>
                                    <span
                                      onClick={() => this.editItem(item)}
                                      title="Editar item"
                                      style={{
                                        paddingRight: "10px"
                                      }}
                                    >
                                      <MdModeEdit />
                                    </span>
                                    <span
                                      onClick={() => this.deleteItem(item)}
                                      title="Remover item"
                                    >
                                      <MdDeleteForever />
                                    </span>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </React.Fragment>
                      ) : (
                        <table className="table table-sm table-hover">
                          <tbody>
                            <tr>
                              <td>
                                <center>Malote vazio.</center>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      )}
                    </div>
                    <div
                      className="modal-footer"
                      style={{
                        padding: "none",
                        borderTop: "none",
                        display: "flex",
                        WebkitBoxAlign: "center",
                        justifyContent: "flex-end"
                      }}
                    >
                      <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={() => this.backHome()}
                        href="#home"
                      >
                        Cancelar
                      </button>
                      <button
                        href="#save"
                        type="button"
                        className="btn btn-primary"
                        onClick={() => this.handleSave()}
                        disabled={this.state.disabled}
                      >
                        Salvar
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </center>
        </div>
      </React.Fragment>
    );
  }
}

export default Register;
